<textarea id="rounds" class="form-control" required rows="10" [(ngModel)]="rounds"></textarea>
